import type { FullComposeViewState } from 'owa-calendar-compose-types';
import { onCloseFullCompose } from 'owa-calendar-compose-form-store';
import clearDomProperties from 'owa-editor-docking-plugin/lib/actions/clearDomProperties';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import { isFeatureEnabled } from 'owa-feature-flags';
import { updateSidePaneType, setViewType } from 'owa-calendar-compose-form-actions';
import { FULL_COMPOSE_VIEW_TYPE_POPOUT } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export function transitionModalToPopoutViewState(viewState: FullComposeViewState) {
    if (
        viewState.currentSidePaneType === SidePaneType.Addins /*Check if addin sidepane is active*/
    ) {
        updateSidePaneType(null /* formId */, SidePaneType.None);
    }

    if (viewState.docking) {
        clearDomProperties(viewState.docking);
    }

    if (isFeatureEnabled('cal-fullcompose-popout-projection')) {
        setViewType(viewState, FULL_COMPOSE_VIEW_TYPE_POPOUT);
        onCloseFullCompose(null);
    }
}
